import { inject, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { UtilService } from '@services/util/util.service';
import { EventsService } from '@services/events/events.service';
import { VariablesService } from '@services/variables/variables.service';
import { NgIf, NgFor } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { CurrencyIconComponent } from '@core-components/currency-icon/currency-icon.component';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, MatRippleModule, CurrencyIconComponent]
})
export class RewardsComponent {

  private router = inject(Router);
  private paymentUtil = inject(PaymentUtilService);
  public util = inject(UtilService);
  public events = inject(EventsService);
  public vars = inject(VariablesService);

  @Input() rewards;
  @Input() currency;
  @Input() campaignId;


  /**Set the reawrd amount for donation */
  setAmount(reward, other?) {
    if (other) {
      const payload = {
        amount_from: ''
      };
      this.trackingEvents(reward);
      this.paymentUtil.selectedReward.next(payload);
      this.router.navigate([], {
        queryParams: { payment: 'form' },
        queryParamsHandling: 'merge'
      });
    } else {
      if (reward.status) {
        this.paymentUtil.selectedReward.next(reward);
        this.router.navigate([], {
          queryParams: { payment: 'form' },
          queryParamsHandling: 'merge'
        });
      }
    }
  }

  /**No push for other reward selection */
  trackingEvents(reward) {
    const claverTap = {
      'Step': 0,
      'id': this.campaignId,
      'Amount': reward.amount,
      'Reward': reward.id,
      'Type_AB': 'typeAB',
      'Page Name': this.vars.campaignType || '',
      'iso_currency': this.currency,
      'Recurring': reward.recurring ? true : false
    };

    if (this.vars.fundraiser) {
      claverTap['Custom Tag'] = this.vars.fundraiser.custom_tag;
    }

    this.events.claverTapPush('New Contribution', claverTap);
  }

}
